import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, IconButton, Collapse, Box, Typography
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

const RegionAreaCountryTable = ({ data }) => {
  const [openRegion, setOpenRegion] = useState(null);
  const [openArea, setOpenArea] = useState({}); // keyed by region+area for nested tracking

  const toggleRegion = (index) => {
    setOpenRegion(openRegion === index ? null : index);
  };

  const toggleArea = (key) => {
    setOpenArea(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell><strong>Region</strong></TableCell>
            <TableCell>Cancelled</TableCell>
            <TableCell>Complete</TableCell>
            <TableCell>In Escalation</TableCell>
            <TableCell>Mitigating Risk</TableCell>
            <TableCell>Not in Scope</TableCell>
            <TableCell>Not Started</TableCell>
            <TableCell>On Hold</TableCell>
            <TableCell>On Track</TableCell>
            <TableCell><strong>Total</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((region, rIdx) => (
            <React.Fragment key={rIdx}>
              <TableRow>
                <TableCell>
                  <IconButton size="small" onClick={() => toggleRegion(rIdx)}>
                    {openRegion === rIdx ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                  </IconButton>
                </TableCell>
                <TableCell>{region.opportunityOwnerRegion}</TableCell>
                <TableCell>{region.cancelled}</TableCell>
                <TableCell>{region.complete}</TableCell>
                <TableCell>{region.inEscalation}</TableCell>
                <TableCell>{region.mitigatingRisk}</TableCell>
                <TableCell>{region.notInCurrentScope}</TableCell>
                <TableCell>{region.notStarted}</TableCell>
                <TableCell>{region.onHold}</TableCell>
                <TableCell>{region.onTrack}</TableCell>
                <TableCell><strong>{region.total}</strong></TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={11} sx={{ paddingBottom: 0, paddingTop: 0 }}>
                  <Collapse in={openRegion === rIdx} timeout="auto" unmountOnExit>
                    <Box margin={1}>
                      <Typography variant="subtitle2">Areas</Typography>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell />
                            <TableCell><strong>Area</strong></TableCell>
                            <TableCell>Cancelled</TableCell>
                            <TableCell>Complete</TableCell>
                            <TableCell>In Escalation</TableCell>
                            <TableCell>Mitigating Risk</TableCell>
                            <TableCell>Not in Scope</TableCell>
                            <TableCell>Not Started</TableCell>
                            <TableCell>On Hold</TableCell>
                            <TableCell>On Track</TableCell>
                            <TableCell><strong>Total</strong></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {region.areas.map((area, aIdx) => {
                            const key = `${rIdx}-${aIdx}`;
                            return (
                              <React.Fragment key={key}>
                                <TableRow>
                                  <TableCell>
                                    <IconButton size="small" onClick={() => toggleArea(key)}>
                                      {openArea[key] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                    </IconButton>
                                  </TableCell>
                                  <TableCell>{area.opportunity_owner_area}</TableCell>
                                  <TableCell>{area.cancelled}</TableCell>
                                  <TableCell>{area.complete}</TableCell>
                                  <TableCell>{area.in_escalation}</TableCell>
                                  <TableCell>{area.mitigating_risk}</TableCell>
                                  <TableCell>{area.not_in_current_scope}</TableCell>
                                  <TableCell>{area.not_started}</TableCell>
                                  <TableCell>{area.on_hold}</TableCell>
                                  <TableCell>{area.on_track}</TableCell>
                                  <TableCell><strong>{area.total}</strong></TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell colSpan={11} sx={{ paddingBottom: 0, paddingTop: 0 }}>
                                    <Collapse in={openArea[key]} timeout="auto" unmountOnExit>
                                      <Box margin={1}>
                                        <Typography variant="subtitle2">Countries</Typography>
                                        <Table size="small">
                                          <TableHead>
                                            <TableRow>
                                              <TableCell><strong>Country</strong></TableCell>
                                              <TableCell>Cancelled</TableCell>
                                              <TableCell>Complete</TableCell>
                                              <TableCell>In Escalation</TableCell>
                                              <TableCell>Mitigating Risk</TableCell>
                                              <TableCell>Not in Scope</TableCell>
                                              <TableCell>Not Started</TableCell>
                                              <TableCell>On Hold</TableCell>
                                              <TableCell>On Track</TableCell>
                                              <TableCell><strong>Total</strong></TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {area.countries.map((country, cIdx) => (
                                              <TableRow key={cIdx}>
                                                <TableCell>{country.opportunity_owner_country}</TableCell>
                                                <TableCell>{country.cancelled}</TableCell>
                                                <TableCell>{country.complete}</TableCell>
                                                <TableCell>{country.in_escalation}</TableCell>
                                                <TableCell>{country.mitigating_risk}</TableCell>
                                                <TableCell>{country.not_in_current_scope}</TableCell>
                                                <TableCell>{country.not_started}</TableCell>
                                                <TableCell>{country.on_hold}</TableCell>
                                                <TableCell>{country.on_track}</TableCell>
                                                <TableCell><strong>{country.total}</strong></TableCell>
                                              </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>
                                      </Box>
                                    </Collapse>
                                  </TableCell>
                                </TableRow>
                              </React.Fragment>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RegionAreaCountryTable;
